const IEC_PROGRAM_NAMES = new Set([
    'working holiday',
    'work holiday',
    'vacances travail',
    'permis de travail ouvert eic',
    'young professionals',
    'jeunes professionnels eic',
    'international co op internship',
    'cooperation internationale stage',
]);

/** Catalog file questions/canada/express-entry.json. */
export const EXPRESS_ENTRY_PROGRAM_ID = 'Express Entry';

function compactName(value: string): string {
    return value
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

function isCanada(country?: string | null): boolean {
    return compactName(country ?? '') === 'canada';
}

/** IEC programs share the Canada country questionnaire. */
export function isCanadaIec(country?: string | null, programName?: string | null): boolean {
    if (!isCanada(country)) return false;
    return IEC_PROGRAM_NAMES.has(compactName(programName ?? ''));
}

/** Federal and provincial programs whose name is an Express Entry program. */
export function isCanadaExpressEntry(
    country?: string | null,
    programName?: string | null
): boolean {
    if (!isCanada(country)) return false;
    const name = compactName(programName ?? '');
    if (!name || name.includes('non express entry') || name.includes('non entree express')) {
        return false;
    }
    return name.includes('express entry') || name.includes('entree express');
}

const CANADA_PRE_ELIGIBILITY_PROGRAMS = new Set([
    'super visa',
    'super visa canada',
    'visitor',
    'visitor visa',
    'visitor visa canada',
    'tourist visa',
    'temporary resident visa',
    'visa de visiteur',
    'visa visiteur',
    'study',
    'study permit',
    'study permit graduate',
    'student visa',
    'permis d etudes',
    'permis d etudes cycles superieurs',
    'work',
    'work permit',
    'work visa',
    'open work permit',
    'post graduation work permit',
    'post graduate work permit',
    'francophone mobility work permit',
    'temporary foreign worker program',
    'international mobility program cusma intra company transferee executives or senior managers',
    'international mobility program cusma intra company transferee specialized knowledge workers',
    'international mobility program cusma investors',
    'international mobility program cusma professionals',
    'international mobility program entrepreneurs',
    'international mobility program significant benefit',
    'permis de travail',
    'permis de travail ouvert',
    'permis de travail post diplome',
]);

export function isCanadaPreEligibility(
    country?: string | null,
    programName?: string | null
): boolean {
    return isCanada(country) && CANADA_PRE_ELIGIBILITY_PROGRAMS.has(compactName(programName ?? ''));
}
